module.exports = __webpack_public_path__ + "static/media/tickets.94be8f66.svg";